import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';

import { SortableHandle } from 'react-sortable-hoc';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import ReorderIcon from '@material-ui/icons/DragHandle';
import Collapse from '@material-ui/core/Collapse';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(1),
    width: '100%',
    height: theme.spacing(4.25),
    alignItems: 'center',
    backgroundColor: theme.colors.grayBlue,
  },
  secondLevel: {
    backgroundColor: theme.colors.grayBlue,
  },
  fieldName: {
    marginLeft: theme.spacing(2),
  },
  fieldNameContainer: {
    flex: 1,
  },
  rightIconsContainer: {
    marginRight: theme.spacing(1),
  },
  removeCircleIconButton: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  removeCircleIcon: {
    height: 16,
    width: 16,
    color: theme.colors.gray1,
  },
  dragHandleIcon: {
    marginLeft: theme.spacing(),
    cursor: 'move',
    color: theme.colors.gray1,
  },
});

const SortableHandleElem = SortableHandle(({ className }) => <ReorderIcon className={className} />);

class Field extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    attribute: PropTypes.object.isRequired,
    secondLevel: PropTypes.bool,
    removeSection: PropTypes.func,
  };

  state = {
    collapse: true,
  };

  handleRemoveClick = () => {
    this.setState({ collapse: false });
  };

  handleOnExited = () => {
    this.props.removeSection(this.props.attribute.name);
  };

  render() {
    const { classes, removeSection, attribute, secondLevel } = this.props;

    return (
      <Collapse in={this.state.collapse} timeout={250} onExited={this.handleOnExited}>
        <div className={classNames(classes.root, { [classes.secondLevel]: secondLevel })}>
          <SortableHandleElem className={classes.dragHandleIcon} />
          <div className={classes.fieldNameContainer}>
            <Typography variant="body1" className={classes.fieldName}>
              {attribute.value.displayName}
            </Typography>
          </div>
          <div className={classes.rightIconsContainer}>
            {removeSection && (
              <IconButton
                aria-label="remove"
                onClick={this.handleRemoveClick}
                className={classes.removeCircleIconButton}
              >
                <RemoveCircleOutlineIcon className={classes.removeCircleIcon} />
              </IconButton>
            )}
          </div>
        </div>
      </Collapse>
    );
  }
}

export default withStyles(styles)(Field);
